<template>
<div class="ticket-item-wrap" :class="item.status > Constants.TICKET_STATUS0 ? 'cur' : 'normal'">
    <div class="info-wrap">
        <div class="item-info-wrap flex rcb">
            <div class="flex rcs">
                <div class="title">门票编号：</div>
                <div class="value text-o">{{item.ticket_no}}</div>
            </div>
            <div class="copy-btn-item" @click="_onPressToCopy(item.ticket_no)" v-if="item.status == Constants.TICKET_STATUS0 && status != Constants.TICKET_STATUS1">
                <div class="btn-title">
                    <span>(</span>
                    <span class="text">复制</span>
                    <span>)</span>
                </div>
            </div>
        </div>
        <div class="item-info-wrap flex rcs none">
            <div class="title">兑换密钥：</div>
            <div class="value text-o">{{item.secret_key}}</div>
            <div class="copy-btn-item" @click="_onPressToCopy(item.secret_key)" v-if="item.status == Constants.TICKET_STATUS0">
                <div class="btn-title">
                    <span>(</span>
                    <span class="text">复制</span>
                    <span>)</span>
                </div>
            </div>
        </div>
        <div class="item-info-wrap flex rcs" v-if="item.status > Constants.TICKET_STATUS0">
            <div class="title">兑换人：</div>
            <div class="value text-o">{{item.student_name || item.student_name_text}}（{{item.student_mobile_text}}）</div>
        </div>
        <div class="item-info-wrap flex rcs" v-if="item.status > Constants.TICKET_STATUS0 || status > Constants.TICKET_STATUS0">
            <div class="title">{{item.status > Constants.TICKET_STATUS1 ? '核销' : '发放'}}时间：</div>
            <div class="value text-o">{{item.update_time}}</div>
        </div>
    </div>
    <div class="btn-wrap flex ccc">
        <div class="btn-item cur" @click="_onPressToNavigate('', 'myTicketGift', {grant_id: item.grant_id})" v-if="status == Constants.TICKET_STATUS1">
            <div class="btn-title">发放</div>
        </div>
        <div class="btn-item cur" @click="_onPressToDealTicket(Constants.RESOLVE)" v-if="item.status == Constants.TICKET_STATUS1">
            <div class="btn-title">通过</div>
        </div>
        <div class="btn-item" @click="_onPressToDealTicket(Constants.REJECT)" v-if="item.status == Constants.TICKET_STATUS1">
            <div class="btn-title">拒绝</div>
        </div>
        <div class="btn-item" @click="_onPressToRevokeTicket()" v-if="item.status == Constants.TICKET_STATUS2 && item.use_status == Constants.TICKET_USE_STATUS1">
            <div class="btn-title">撤销</div>
        </div>
        <div class="btn-item cur" v-if="item.use_status == Constants.TICKET_USE_STATUS2">
            <div class="btn-title">已使用</div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "myTicketItem",
    props: ['item', 'status'],
    data() {
        return {

        };
    },
    methods: {
        onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            console.log('url---->', url);
            window.location.href = url;
        },

        _onPressToCopy(copyText) {
            this.$copyText(copyText)
                .then((e) => {
                    this.ToastManager('复制成功');
                }, (e) => {
                    console.log('e---->', e);
                })
        },

        async _onPressToDealTicket(check_status) {
            let url = this.API.salon_ticket_check;
            let data = {
                check_status,
                ticket_id: this.item.id,
            };

            let params = {
                title: '温馨提示',
                message: '确定要核销该门票吗？',
            };
            this.AlertManager.confirm(params).then(async () => {
                let result = await this.$post(url, data);
                this.ToastManager(result.msg);
                if (result.code === this.GLOBAL.SUCCESS_CODE) {
                    this.$emit('onRefresh', true);
                }
            });

        },

        async _onPressToRevokeTicket(check_status) {
            let url = this.API.user_ticket_revoke;
            let data = {
                ticket_id: this.item.id,
            };

            let params = {
                title: '温馨提示',
                message: '确定要撤销该门票吗？',
            };
            this.AlertManager.confirm(params).then(async () => {
                let result = await this.$post(url, data);
                this.ToastManager(result.msg);
                if (result.code === this.GLOBAL.SUCCESS_CODE) {
                    this.$emit('onRefresh', true);
                }
            });

        }
    },
};
</script>

<style lang="less" scoped>
.ticket-item-wrap {
    padding: 10px;
    display: flex;
    background: #fff;
    box-sizing: border-box;
    border-radius: 5px;
    align-items: center;
    &.normal {
        padding-left: 2rem;
        border-bottom: 1px dashed #eee;
        &:last-of-type {
            border: 0;
        }
    }

    &.cur {
        margin: 10px 15px 0;
    }

    .info-wrap {
        flex: 1;
        overflow: hidden;
        margin-right: 1rem;

        .item-info-wrap {
            flex: 1;
            flex-shrink: 0;
            font-size: 1.4rem;

            .title {
                width: 7rem;
                color: #333;
                flex-shrink: 0;
                min-width: 7rem;
                text-align-last: justify;
            }

            .value {
                flex: 1;
                color: #666;
            }

            .copy-btn-item {
                width: 5rem;
                margin-left: 1rem;

                .btn-title {
                    color: #7180eb;
                    font-size: 1.2rem;
                    white-space: nowrap;
                    .text {
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    .btn-wrap {

        .btn-item {
            width: 62px;
            height: 26px;
            color: #fff;
            margin: .5rem 0;
            font-size: 1.2rem;
            border-radius: .5rem;
            background: linear-gradient(205deg, #9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);

            &.cur {
                color: #7181EB;
                background: #fff;
                border: 1px solid #7181EB;
            }
        }

    }
}
</style>
